import * as React from "react"
import * as ReactDOM from "react-dom"
import 'react-dates/initialize';
import { DateRangePicker, DateRangePickerShape, FocusedInputShape } from 'react-dates';
import * as moment_base from 'moment';
import { Moment } from 'moment';
import { extendMoment, DateRange } from 'moment-range';
import * as Immutable from 'immutable'

import { default as PeriodPicker, StartEnd, DisabledProps, PrefixProps } from './PeriodPicker'

const moment = extendMoment(moment_base);

const now = Date.now()

type Props = StartEnd & PrefixProps & DisabledProps & {
  onDatesChange: (range: StartEnd) => void
  onFocusChange: (fi: FocusedInputShape) => void
  focusedInput: FocusedInputShape
  startDatePlaceholderText?: string
  endDatePlaceholderText?: string
}

type State = {  }


export default class GlobalPeriodPicker extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
  }

  renderDay(day: Moment) {
    return <div className={'CalendarDay_button__contents'}>{day.date()}</div>
  }

  onFocusChange(fi: FocusedInputShape) {
    this.setState({ focusedInput: fi });
  }

  render() {
    return (
      <div>
        <PeriodPicker
          {...this.props}
          renderDay={(day: Moment) => this.renderDay(day)}
          isDayBlocked={(day: Moment) => day.isBefore(now)}
          isOutsideRange={(day: Moment) => day.isBefore(now)}
          startDatePlaceholderText={this.props.startDatePlaceholderText}
          endDatePlaceholderText={this.props.endDatePlaceholderText}
        />
      </div>
    )
  }
}
